import type { ProductPlaceholderModelProps } from '@/components/shared/product-placeholder/product-placeholder.model'
import { useProductPlaceholderModel } from '@/components/shared/product-placeholder/product-placeholder.model'
import { ProductPlaceholderView } from '@/components/shared/product-placeholder/product-placeholder.view'

export function ProductPlaceholderViewModel(
  props: ProductPlaceholderModelProps,
) {
  const model = useProductPlaceholderModel(props)
  return <ProductPlaceholderView {...model} />
}
